import React, { useRef, memo } from "react";

const IPInput = memo(({ value, onChange, disabled }) => {
  const ref0 = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const inputRefs = [ref0, ref1, ref2, ref3];

  const parts = value ? value.split(".") : [];
  const segments = [0, 1, 2, 3].map((i) =>
    parts[i] !== undefined ? String(parts[i]) : ""
  );

  const isInvalid = (val) => {
    if (val === "") return false;
    const num = Number(val);
    return isNaN(num) || num < 0 || num > 255;
  };

  const handleSegmentChange = (index, rawValue) => {
    const clean = rawValue.replace(/[^0-9]/g, "").slice(0, 3);
    if (clean !== "" && Number(clean) > 255) {
      return;
    }

    const newSegments = [...segments];
    newSegments[index] = clean;

    if (clean.length === 3 && index < 3 && inputRefs[index + 1].current) {
      inputRefs[index + 1].current.focus();
    }

    if (onChange) {
      onChange(newSegments.join("."));
    }
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      segments[index] === "" &&
      index > 0 &&
      inputRefs[index - 1].current
    ) {
      inputRefs[index - 1].current.focus();
    }
  };

  const boxStyle = (val) => ({
    width: 38,
    textAlign: "center",
    border: isInvalid(val) ? "1px solid #e74c3c" : "1px solid #ccc",
    borderRadius: 4,
    padding: "4px 2px",
    fontSize: 12,
    background: disabled ? "#cccccc" : "#ffffff",
    color: disabled ? "#888888" : "#1C2C49",
    outline: "none",
    fontFamily: "inherit",
    transition: "border-color 0.2s",
  });

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
      {[0, 1, 2, 3].map((index) => (
        <React.Fragment key={index}>
          <input
            ref={inputRefs[index]}
            type="text"
            inputMode="numeric"
            value={segments[index]}
            maxLength={3}
            disabled={disabled}
            onChange={(e) => handleSegmentChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            style={boxStyle(segments[index])}
          />
          {index < 3 && (
            <span
              style={{
                fontWeight: "bold",
                color: "#046664",
                fontSize: 14,
                lineHeight: 1,
                userSelect: "none",
              }}
            >
              .
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
});

export default IPInput;
